// Decisione "mostro l'intro SONITECH al login oppure no" — modulo puro, testato.
//
// Regola del titolare (07/10/2026): l'intro si vede SEMPRE, a ogni apertura del sito —
// e' la presentazione dell'applicazione, non un saluto una tantum. Prima si vedeva una
// volta al giorno; la data continua a essere scritta perche' racconta l'ultimo accesso e
// non costa nulla, ma non decide piu' niente.
// L'unica eccezione resta chi chiede meno movimento: a lui l'intro non si mostra mai.
// Lo storage puo' mancare o sollevare (navigazione privata, criteri del browser): in quel
// caso l'intro si mostra e nulla si rompe.

export const CHIAVE_INTRO = 'tim456_login_intro_vista';

/** Data locale 'AAAA-MM-GG' (non UTC: la giornata e' quella di chi guarda). */
export function dataLocale(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function introDaMostrare({ riduciMovimento }) {
  return !riduciMovimento;
}

// `storage` non passato = localStorage del browser. L'accesso a window.localStorage puo'
// sollevare gia' di suo, per questo avviene dentro il try.
function risolviStorage(storage) {
  if (storage !== undefined) return storage;
  return typeof window !== 'undefined' ? window.localStorage : null;
}

export function leggiUltimaVista(storage) {
  try {
    const s = risolviStorage(storage);
    return s ? s.getItem(CHIAVE_INTRO) : null;
  } catch {
    return null;
  }
}

export function segnaIntroVista(oggi, storage) {
  try {
    const s = risolviStorage(storage);
    if (s) s.setItem(CHIAVE_INTRO, oggi);
  } catch {
    /* storage non disponibile: pazienza, domani (o al prossimo accesso) si rivede */
  }
}

export function riduciMovimentoAttivo() {
  try {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
